import React, { useState } from "react";
import SingleSelectWithSearch from "../../../components/dropdown/SingleSelectWithSearch";
import TextInput from "../../../components/UIComponent/TextInput";
import ModalBasic from "../../component/ModalBasic";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";

export const rowData = [];
export const colDefs = [];

export const generalPurchaseColdefs = [
    {
        field: "productName",
        headerName: "Item Details",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
    {
        field: "quantity",
        headerName: "Inward Quantity",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
    {
        field: "rate",
        headerName: "Rate",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
    {
        field: "amount",
        headerName: "Amount",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
    {
        field: "discount",
        headerName: "Discount",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
    {
        field: "chargesAmt",
        headerName: "Extra Charges",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
    {
        field: "netTotal",
        headerName: "Taxable Amount",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
    {
        field: "sgst",
        headerName: "SGST",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
    {
        field: "sgstAmount",
        headerName: "SGST Amt",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
    {
        field: "cgst",
        headerName: "CGST",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
    {
        field: "cgstAmount",
        headerName: "CGST Amt",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
    {
        field: "igst",
        headerName: "IGST",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
    {
        field: "igstAmount",
        headerName: "IGST Amt",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
    {
        field: "netPayble",
        headerName: "Net Total",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
    {
        field: "remarks",
        headerName: "Remarks",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
];
export const generalPurchaseRowData = [
];

export const table2Data = [];
export const table2ColDefs = [];



export const GeneralPurchasePopUp = (props) => {

    const [open, setOpen] = useState(false);

    return (
        <ModalBasic
            id="salaryBankTransfer"
            classParams={`!w-[75%] overflow-y-auto ${open ? 'h-full' : ''}`}
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}>
            <div className="input-fields p-[30px]">
                <div className="item-grp">
                    <div className="tabbing-btns flex gap-5 items-center mb-3">
                        <span className={` text-[16px] py-[5px] px-[15px] rounded-[8px] font-semibold cursor-pointer ${open ? "text-blue bg-lightBlue hover:bg-[#3f8cff33]" : "text-white bg-blue"}`} onClick={() => setOpen(false)}>Material inward details</span>
                        <span className={` text-[16px] py-[5px] px-[15px] rounded-[8px] font-semibold cursor-pointer ${open ? "text-white bg-blue" : "text-blue bg-lightBlue hover:bg-[#3f8cff33]"}`} onClick={() => setOpen(true)}>More details</span>
                    </div>
                    {!open && (
                        <>
                            <div className="item-inner grid grid-cols-4 gap-2.5 mt-2.5 mb-2 pb-[8px] border-b border-slate-200">
                                <div className="inputOuter-grp grid grid-cols-3 col-span-2 gap-2.5">
                                    <div className="input-grp">
                                        <label>Inward no</label>
                                        <TextInput type="text" id="inwardNo" name="inwardNo" value={props.materialInwardDetails.inwardNo} handleChange={(event) => props.handleChange(event, "inwardNo")} disabled />
                                    </div>
                                    <div className="input-grp">
                                        <label>Inward date</label>
                                        <TextInput type="date" id="inwardDate" name="inwardDate" value={props.materialInwardDetails.inwardDate} handleChange={(event) => props.handleChange(event, "inwardDate")} disabled />
                                    </div>
                                    <div className="input-grp">
                                        <label>Inward type</label>
                                        <SingleSelectWithSearch
                                            drpIdentity={"inwardType"}
                                            optionArray={props.materialInwardDetails.inwardType}
                                            value={props.materialInwardDetails.inwardTypeId}
                                            searchText={props.materialInwardDetails.inwardTypeName}
                                            //className={props.validState?.error?.paymentMode !== undefined ? "error" : ""}
                                            setFilterParameters={props.setFilterParameters}
                                            classParams={props.validStateMaterial?.error?.inwardTypeId !== undefined ? "error" : ""}
                                        />
                                    </div>
                                </div>
                                <div className="input-grp col-span-2">
                                    <label>Gate pass no</label>
                                    <SingleSelectWithSearch
                                        drpIdentity={"gatePassNo"}
                                        optionArray={props.materialInwardDetails.gatePassNoList}
                                        value={props.materialInwardDetails.idGatePass}
                                        searchText={props.materialInwardDetails.gatePassNo}
                                        handleChangeTest={props.handleSearching}
                                        //className={props.validState?.error?.paymentMode !== undefined ? "error" : ""}
                                        setFilterParameters={props.setFilterParameters}
                                        classParams={props.validStateMaterial?.error?.idGatePass !== undefined ? "error" : ""}
                                        isSecondFieldRequire={true}
                                    />
                                    {/* <SingleSelectWithSearch id="gatePassNo" name="gatePassNo" value={props.materialInwardDetails.gatePassNo} handleChangeTest={(event) => props.handleSelectChange(event, "gatePassNo")} className={props.validState?.error?.gatePassNo !== undefined ? "error" : ""} /> */}
                                </div>
                                <div className="input-grp">
                                    <label>Invoice no</label>
                                    <TextInput type="text" id="invoiceNo" name="invoiceNo" value={props.materialInwardDetails.invoiceNo} handleChange={(event) => props.handleChange(event, "invoiceNo")}
                                    // className={props.validState?.error?.invoiceNo !== undefined ? "error" : ""}
                                    />
                                </div>
                                <div className="input-grp">
                                    <label>Invoice date</label>
                                    <TextInput type="date" id="invoiceDate" name="invoiceDate" value={props.materialInwardDetails.invoiceDate} handleChange={(event) => props.handleChange(event, "invoiceDate")}
                                    // className={props.validState?.error?.invoiceDate !== undefined ? "error" : ""} 
                                    />
                                </div>

                            </div>
                            <span className="text-blue text-[16px] font-semibold ">Inward items details</span>
                            <div className="item-inner grid grid-cols-5 gap-2.5 mb-3 mt-1.5">
                                <div className="input-grp col-span-2">
                                    <label>Item name</label>
                                    <div className="inputInner-grp flex gap-0.5">
                                        <SingleSelectWithSearch
                                            drpIdentity={"itemName"}
                                            optionArray={props.inwardItemDetails.itemNameList}
                                            value={props.inwardItemDetails.idGeneralProduct}
                                            searchText={props.inwardItemDetails.productName}
                                            //className={props.validState?.error?.paymentMode !== undefined ? "error" : ""}
                                            setFilterParameters={props.setFilterParametersItme}
                                            handleChangeTest={props.handleSearching}
                                            classParams={props.validStateInward?.error?.idGeneralProduct !== undefined ? "error" : ""}
                                        />
                                        {/* <SingleSelectWithSearch id="itemName" name="itemName" value={props.inwardItemDetails.itemName} handleChangeTest={(event) => props.handleSelectChange(event, "itemName")} className={props.validState?.error?.itemName !== undefined ? "error" : ""} /> */}
                                        {/* <button className="prm-btn !rounded-[8px] !px-[13px] !w-fit"><FontAwesomeIcon icon={faPlus} /></button> */}
                                    </div>
                                </div>
                                <div className="input-grp">
                                    <label>Unit</label>
                                    <SingleSelectWithSearch
                                        drpIdentity={"unit"}
                                        optionArray={props.inwardItemDetails.unitList}
                                        value={props.inwardItemDetails.idUnit ? props.inwardItemDetails.idUnit : 0}
                                        searchText={props.inwardItemDetails.unitDescription}
                                        //className={props.validState?.error?.paymentMode !== undefined ? "error" : ""}
                                        setFilterParameters={props.setFilterParameters}
                                        classParams={props.validStateInward?.error?.idUnit !== undefined ? "error" : ""}
                                    //handleChangeTest={props.handleSearching}
                                    //disabled={true}
                                    />
                                    {/* <SingleSelectWithSearch id="unit" name="unit" value={props.inwardItemDetails.unitList} handleChangeTest={(event) => props.handleSelectChange(event, "unit")} className={props.validState?.error?.unit !== undefined ? "error" : ""} /> */}
                                </div>
                                <div className="input-grp">
                                    <label>Quantity</label>
                                    <TextInput type="number" id="quantity" name="quantity" value={props.inwardItemDetails.quantity} handleChange={(event) => props.handleChangeForItem(event, "quantity")} className={props.validStateInward?.error?.quantity !== undefined ? "error" : ""} />
                                </div>
                                <div className="input-grp">
                                    <label>Rate</label>
                                    <TextInput type="number" id="rate" name="rate" value={props.inwardItemDetails.rate} handleChange={(event) => props.handleChangeForItem(event, "rate")} className={props.validStateInward?.error?.rate !== undefined ? "error" : ""} />
                                </div>
                            </div>
                            <div className="item-inner grid grid-cols-6 gap-2.5 mb-3">
                                <div className="input-grp">
                                    <label>Amount</label>
                                    <TextInput type="number" id="amount" name="amount" value={props.inwardItemDetails.amount} handleChange={(event) => props.handleChangeForItem(event, "amount")} disabled />
                                </div>
                                <div className="input-grp">
                                    <label>Discount(%)</label>
                                    <TextInput type="number" max={100} id="discount" name="discount" value={props.inwardItemDetails.discount} handleChange={(event) => props.handleChangeForItem(event, "discount")}
                                    // className={props.validStateInward?.error?.discount !== undefined ? "error" : ""} 
                                    />
                                </div>
                                <div className="input-grp">
                                    <label>Charges amount</label>
                                    <TextInput type="number" id="chargesAmt" name="chargesAmt" value={props.inwardItemDetails.chargesAmt} handleChange={(event) => props.handleChangeForItem(event, "chargesAmt")}
                                    // className={props.validStateInward?.error?.chargesAmt !== undefined ? "error" : ""} 
                                    />
                                </div>
                                <div className="input-grp">
                                    <label>Net total</label>
                                    <TextInput type="number" id="netTotal" name="netTotal" value={props.inwardItemDetails.netTotal} handleChange={(event) => props.handleChangeForItem(event, "netTotal")} disabled />
                                </div>
                                <div className="input-grp">
                                    <label>Tax group</label>
                                    <div className="inputInner-grp flex gap-0.5">
                                        <SingleSelectWithSearch
                                            drpIdentity={"taxGroup"}
                                            optionArray={props.inwardItemDetails.taxGroupList}
                                            value={props.inwardItemDetails.idTaxGroup}
                                            searchText={props.inwardItemDetails.taxGroup}
                                            //className={props.validState?.error?.paymentMode !== undefined ? "error" : ""}
                                            setFilterParameters={props.setFilterParametersItme}
                                            classParams={props.validStateInward?.error?.idTaxGroup !== undefined ? "error" : ""}
                                        //handleChangeTest={props.handleSearching}
                                        //disabled={true}
                                        />
                                        {/* <SingleSelectWithSearch id="taxGroup" name="taxGroup" value={props.inwardItemDetails.taxGroup} handleChangeTest={(event) => props.handleSelectChange(event, "taxGroup")} className={props.validState?.error?.taxGroup !== undefined ? "error" : ""} /> */}
                                        {/* <button className="prm-btn !rounded-[8px] !px-[13px] !w-fit"><FontAwesomeIcon icon={faPlus} /></button> */}
                                    </div>
                                </div>
                                <div className="input-grp">
                                    <label>SGST {props.materialInwardDetails.inwardTypeName === 'INTRASTATE' && props.inwardItemDetails.sgst > 0 ? `- ${props.inwardItemDetails.sgst}` : ""}</label>
                                    <TextInput type="number" id="sgstAmount" name="sgstAmount" value={props.inwardItemDetails.sgstAmount} handleChange={(event) => props.handleChangeForItem(event, "sgstAmount")} disabled />
                                </div>
                            </div>
                            <div className="item-inner grid grid-cols-6 gap-2.5 mb-3">
                                <div className="input-grp">
                                    <label>CGST {props.materialInwardDetails.inwardTypeName === 'INTRASTATE' && props.inwardItemDetails.cgst > 0 ? `- ${props.inwardItemDetails.cgst}` : ""}</label>
                                    <TextInput type="number" id="cgstAmount" name="cgstAmount" value={props.inwardItemDetails.cgstAmount} handleChange={(event) => props.handleChangeForItem(event, "cgstAmount")} disabled />
                                </div>
                                <div className="input-grp">
                                    <label>IGST {props.inwardItemDetails.igst > 0 ? props.materialInwardDetails.inwardTypeName === 'INTRASTATE' ? "" : `-${props.inwardItemDetails.igst}` : ""}</label>
                                    <TextInput type="number" id="igstAmount" name="igstAmount" value={props.inwardItemDetails.igstAmount} handleChange={(event) => props.handleChangeForItem(event, "igstAmount")} disabled />
                                </div>
                                <div className="input-grp">
                                    <label>Net total</label>
                                    <TextInput type="number" id="netPayble" name="netPayble" value={props.inwardItemDetails.netPayble} handleChange={(event) => props.handleChangeForItem(event, "netPayble")} disabled />
                                </div>
                                <div className="input-grp col-span-2">
                                    <label>Remarks</label>
                                    <TextInput type="text" id="remarks" name="remarks" value={props.inwardItemDetails.remarks} handleChange={(event) => props.handleChangeForItem(event, "remarks")} className={props.validState?.error?.remarks !== undefined ? "error" : ""} />
                                </div>
                                {props.inwardItemDetails.key === "" ?
                                    <>
                                        <button className="save-btn btns mt-auto mb-[2px]" onClick={() => props.insertItem("Insert")}> Insert</button>
                                    </>
                                    :
                                    <>
                                        <button className="save-btn btns mt-auto mb-[2px]" onClick={() => props.insertItem("Update")}> Update</button>
                                    </>
                                }
                            </div>
                            {/* <div className="item-inner grid grid-cols-4 gap-2.5 mb-3">
                    </div> */}
                            <div className="ledger-table h-[25vh] pb-[8px]">
                                <div className="table-inner h-full">
                                    <AgGridReact
                                        rowData={props.generalPurchaseRowData}
                                        columnDefs={generalPurchaseColdefs}
                                        onCellClicked={props.handleCellClickItemList}
                                    />
                                </div>
                            </div>
                            <span className="text-blue text-[16px] font-semibold">Amount details</span>
                            <div className="item-inner grid grid-cols-5 gap-2.5 mb-2.5 mt-1.5">
                                <div className="input-grp">
                                    <label>Total quantity</label>
                                    <TextInput type="number" id="totalQty" name="totalQty" value={props.amountDetails.totalQty} handleChange={(event) => props.handleChange(event, "totalQty")} disabled />
                                </div>
                                <div className="input-grp">
                                    <label>Total amount</label>
                                    <TextInput type="number" id="totalAmt" name="totalAmt" value={props.amountDetails.totalAmt} handleChange={(event) => props.handleChange(event, "totalAmt")} disabled />
                                </div>
                                <div className="input-grp">
                                    <label>Extra charges</label>
                                    <TextInput type="number" id="extraCharges" name="extraCharges" value={props.amountDetails.extraCharges} handleChange={(event) => props.handleChange(event, "extraCharges")} disabled />
                                </div>
                                <div className="input-grp">
                                    <label>Discount amount</label>
                                    <TextInput type="number" id="discountAmt" name="discountAmt" value={props.amountDetails.totalDiscountAmt} handleChange={(event) => props.handleChange(event, "discountAmt")} disabled />
                                </div>
                                <div className='input-grp'>
                                    <label>Taxable amount</label>
                                    <TextInput type='number'
                                        id='taxableAmt' name='taxableAmt'
                                        value={props.amountDetails.taxableAmt}
                                        handleChange={(event) => props.handleChangeForPayment(event, 'taxableAmt')}
                                        disabled
                                    />
                                </div>
                                <div className="input-grp">
                                    <label>Tax amount</label>
                                    <TextInput
                                        type="number"
                                        id="totalTaxAmt"
                                        name="totalTaxAmt"
                                        value={props.amountDetails.totalTaxAmt}
                                        handleChange={(event) => props.handleChangeFinalCalculation(event, "taxAmt")}
                                        disabled
                                    />
                                </div>
                                <div className="input-grp">
                                    <label>TCS(%)</label>
                                    <TextInput type="number" id="tcsPercentage" name="tcsPercentage" value={props.amountDetails.tcsPercentage} handleChange={(event) => props.handleChangeFinalCalculation(event, "tcsPercentage")} />
                                </div>
                                <div className="input-grp">
                                    <label>TCS amount</label>
                                    <TextInput type="number" id="tcsAmt" name="tcsAmt" value={props.amountDetails.tcsAmt} handleChange={(event) => props.handleChange(event, "tcsAmt")} disabled />
                                </div>
                                <div className='input-grp'>
                                    <label>Adjustable amount</label>
                                    <TextInput type='number'
                                        id='adjustableAmt' name='adjustableAmt'
                                        value={props.amountDetails.adjustableAmt}
                                        handleChange={(event) => props.handleChangeFinalCalculation(event, 'adjustableAmt')}
                                        className='font-semibold'
                                    />
                                </div>
                                <div className="input-grp">
                                    <label>Final amount</label>
                                    <TextInput type="number" id="finalAmt" name="finalAmt" value={props.amountDetails.finalAmt} handleChange={(event) => props.handleChange(event, "finalAmt")} disabled />
                                </div>
                            </div>
                            <div className="btn-grp inline-flex gap-2.5">

                                <button className="update-btn btns"
                                    onClick={() => props.submitGeneralPurchase()}
                                    disabled={props.isSaving}
                                >
                                    {props.materialInwardDetails.idGeneralPurchase > 0 ? "Update" : "Save"}
                                </button>
                                <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                                {/* <button className="edit-btn btns">Delete</button> */}
                            </div>
                        </>
                    )}
                    {open && (
                        <>
                            <div className="item-inner grid grid-cols-4 gap-2.5 mb-3">
                                <div className="input-grp">
                                    <label>Mode of delivery</label>
                                    <TextInput type="text" id="modeOfDelivery" disabled name="modeOfDelivery" value={props.materialInwardDetails.modeOfDelivery} handleChange={(event) => props.handleChange(event, "modeOfDelivery")} className={props.validState?.error?.modeOfDelivery !== undefined ? "error" : ""} />
                                </div>
                                <div className="input-grp col-span-2">
                                    <label>Select vendor</label>
                                    <SingleSelectWithSearch
                                        drpIdentity={"partyAccountGeneral"}
                                        optionArray={props.materialInwardDetails.partyAccountGeneral}
                                        value={props.materialInwardDetails.idPartyAccount}
                                        searchText={props.materialInwardDetails.partyACName}
                                        classParams={props.validStateMaterial?.error?.vendor !== undefined ? "error" : ""}
                                        setFilterParameters={props.setFilterParameters}
                                        handleChangeTest={props.handleSearching}
                                    // disabled={true}
                                    />
                                </div>
                                <div className="input-grp">
                                    <label>Mode of payment</label>
                                    <TextInput type="text" id="modeOfPayment" name="modeOfPayment" value={props.materialInwardDetails.modeOfPayment} handleChange={(event) => props.handleChange(event, "modeOfPayment")}
                                    // className={props.validState?.error?.modeOfPayment !== undefined ? "error" : ""} 
                                    />
                                </div>
                            </div>
                            <div className="item-inner grid grid-cols-4 gap-2.5 mb-3">
                                <div className="input-grp">
                                    <label>Person name</label>
                                    <TextInput type="text" id="personName" name="personName" value={props.materialInwardDetails.personName} handleChange={(event) => props.handleChange(event, "personName")}
                                    // className={props.validState?.error?.personName !== undefined ? "error" : ""} 
                                    />
                                </div>
                                <div className="input-grp">
                                    <label>Vehicle no</label>
                                    <TextInput type="text" id="vehicleNo" name="vehicleNo" value={props.materialInwardDetails.vehicleNo} handleChange={(event) => props.handleChange(event, "vehicleNo")}
                                    // className={props.validState?.error?.vehicleNo !== undefined ? "error" : ""} 
                                    />
                                </div>
                                <div className="input-grp">
                                    <label>Select file</label>
                                    <TextInput type="file" multiple accept="image/*, .pdf" id="selectFile" name="selectFile" value={props.materialInwardDetails.selectFile} handleChange={(event) => props.handleChange(event, "selectFile")}
                                    // className={props.validState?.error?.selectFile !== undefined ? "error" : ""} 
                                    />
                                </div>
                                <div className="input-grp">
                                    <label>Inward by</label>
                                    <SingleSelectWithSearch
                                        drpIdentity={"inwardBy"}
                                        optionArray={props.materialInwardDetails.inwardByList}
                                        value={props.materialInwardDetails.idInwardBy}
                                        searchText={props.materialInwardDetails.inwardBy}
                                        // className={props.validState?.error?.paymentMode !== undefined ? "error" : ""}
                                        setFilterParameters={props.setFilterParameters}
                                    />
                                </div>
                            </div>
                            <div className="item-inner grid grid-cols-2 gap-2.5">
                                <div className="input-grp">
                                    <label>Address</label>
                                    <textarea rows={3} type="text" id="address" name="address" value={props.materialInwardDetails.address} onChange={(event) => props.handleChange(event, "address")}
                                        style={{ height: "100%" }}
                                    />
                                </div>
                            </div>
                        </>
                    )}

                </div>
            </div>
        </ModalBasic>
    );
}